export default {"src":"/_next/static/media/transparent-pricing.43893a5e.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};